<footer class="logo-outer-container">
  <p class="label">Developed by</p>
  <div style="display: flex">
    <div class="logo-inner-container">
      <img
        src="https://d1sips1sizw66e.cloudfront.net/gba/images/logos/itc_logo_white.svg"
        alt="ITC Logo"
        class="logo"
        height="34px"
        width="80.75px"
      />
    </div>
  </div>
</footer>
